import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useTransactionComments from 'tennders-transactions/hooks/useTransactionComments'
import { GButton, OnlyInputContainer, TextInput } from 'tennders-common/form/components'
import { useToast } from 'tennders-common/hooks/useToast'
import usePopup from 'tennders-common/hooks/usePopup'
import GModal from 'tennders-market/common/components/element/GModal'
import { ModalProps } from 'tennders-common/types/ModalProps'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchRequestUpdate } from 'tennders-common/stores/prompt/action'
import TSummary from './TSummary'

const MRequestUpdate = (props: ModalProps) => {
  const [body, setBody] = useState<string>('')
  const [submitting, setsubmitting] = useState(false)
  const { postComment } = useTransactionComments()
  const { toastError } = useToast()
  const { popWarning } = usePopup()
  const requestUpdate = useSelector((state : StateType) => state.prompt.requestUpdate)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const close = () => dispatch(dispatchRequestUpdate(false))

  const send = async (e) => {
    if (submitting) {
      return
    }
    if (e) {
      e.preventDefault()
    }
    setsubmitting(true)
    const response = await postComment({
      ...requestUpdate.params,
      body,
      isTrack: true
    })
    setsubmitting(false)
    if (response && response.error) {
      toastError(response.error)
    } else {
      close()
      popWarning({
        msg: requestUpdate?.transaction?.isMarketPlaced
          ? t('modals:trackMsgForMPSent')
          : t('modals:trackMsg'),
        title: t('modals:track')
      })
      setBody('')
    }
  }

  return (
    requestUpdate
      ? (
        <GModal size="80%" isOpen close={close} {...props}>
          <div className="tennders-modal-body w-100">
            <div className="d-flex">
              <TSummary t={t} transaction={requestUpdate?.transaction} />
              <div className="col-2 bg-color-light-gray">
                <div className="p-20">
                  <>
                    <h3>{t('modals:track')}</h3>
                    {requestUpdate?.transaction?.isMarketPlaced
                      ? <p>{t('modals:trackMsgForMP')}</p>
                      : <p>{t('modals:trackMsgWithComment')}</p>}
                  </>
                  <div className="d-flex align-center mt-20">
                    <OnlyInputContainer
                      name="body"
                      form={{ body }}
                      onChange={(k, v) => setBody(v)}
                      renderInput={(rest) => (
                        <TextInput
                          className="form-input w-auto flex-grow-vert mr-8"
                          {...rest}
                        />
                      )}
                    />
                    <GButton
                      disabled={body?.length === 0}
                      submitting={submitting}
                      onClick={body?.length === 0 ? () => null : send as any}
                      className="btn-border standard-btn cursor-pointer"
                    >
                      {t('modals:send')}
                    </GButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </GModal>
      )
      : null
  )
}

export default MRequestUpdate
